export const APP_PRECACHE_CONFIG_TOKEN = 'APP_PRECACHE_CONFIG_TOKEN';
export const APP_MANIFEST_JSON_FILE = 'app-manifest.json';
export const SERVICE_WORKER_FILE_NAME = 'sw.js';
export const APP_REVISION_LOCAL_STORAGE_KEY = 'currentAppRevision';
